import React, { useRef, useState } from 'react'
import { Modal } from '@material-ui/core'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import SaveIcon from '@material-ui/icons/Save'
import CancelIcon from '@material-ui/icons/Cancel'

import ButtonStyled from 'components/CommonUI/Button/Button'

const CropFileModal = ({ file, handleClose, handleSave }) => {
  const imageRef = useRef()
  const [croppedImageUrl, setCroppedImageUrl] = useState(null)
  const [cropProps, setCrop] = useState({
    unit: 'px', // по умолчанию, может быть 'px' или '%'
    width: 200,
    height: 200,
    aspect: 1 / 1,
  })

  const onImageLoaded = (image) => {
    imageRef.current = image
  }

  const onCropComplete = (crop) => {
    makeClientCrop(crop)
  }

  const onCropChange = (crop) => {
    setCrop(crop)
  }

  const makeClientCrop = async (crop) => {
    if (imageRef?.current && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(
        imageRef.current,
        crop,
        'newFile.jpg'
      )
      setCroppedImageUrl(croppedImageUrl)
    }
  }

  function getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas')
    const pixelRatio = window.devicePixelRatio
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const ctx = canvas.getContext('2d')

    canvas.width = crop.width * pixelRatio * scaleX
    canvas.height = crop.height * pixelRatio * scaleY

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    ctx.imageSmoothingQuality = 'high'

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    )

    // eslint-disable-next-line no-undef
    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error('Canvas is empty')
            return
          }
          blob.name = fileName

          //window.URL.revokeObjectURL(newImageRef?.current)
          //newImageRef.current = window.URL.createObjectURL(blob)
          resolve(blob)
        },
        'image/jpeg',
        1
      )
    })
  }

  const _handleClose = () => {
    handleClose()
  }

  const _handleSave = () => {
    handleSave(croppedImageUrl)
  }

  return (
    <Modal open={true} onClose={_handleClose} className="crop_modal_container">
      <div className="crop_modal_dialog">
        <ReactCrop
          src={file}
          crop={cropProps}
          ruleOfThirds
          onImageLoaded={onImageLoaded}
          onComplete={onCropComplete}
          onChange={onCropChange}
          className={'crop_modal_image'}
        />
        <div className="crop_modal_buttons">
          <ButtonStyled
            startIcon={<SaveIcon />}
            className="crop_modal_button"
            onClick={_handleSave}
          >
            Save
          </ButtonStyled>
          <ButtonStyled startIcon={<CancelIcon />} onClick={_handleClose}>
            Cancel
          </ButtonStyled>
        </div>
      </div>
    </Modal>
  )
}

export default CropFileModal
